/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillinglegalname3Inputs */

const en_profilebillinglegalname3 = /** @type {(inputs: Profilebillinglegalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company name`)
};

const de_profilebillinglegalname3 = /** @type {(inputs: Profilebillinglegalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenname`)
};

/**
* | output |
* | --- |
* | "Company name" |
*
* @param {Profilebillinglegalname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillinglegalname3 = /** @type {((inputs?: Profilebillinglegalname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillinglegalname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillinglegalname3(inputs)
	return de_profilebillinglegalname3(inputs)
});
export { profilebillinglegalname3 as "profileBillingLegalName" }